import http from '@/assets/common/http';
// ------------------------------------------配送单管理拉取数据
export function sendingOrderFun(data) {
  const params = {
    SERVICE_ID: '10021',
    OTYPE: 1,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// -------------------------------------------导出三列配送单
export function exportSendOrderFunTre(data) {
  const params = {
    SERVICE_ID: '10021',
    OTYPE: 4,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// -------------------------------------------导出配送单
export function exportSendOrderFun(data) {
  const params = {
    SERVICE_ID: '10021',
    OTYPE: 2,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// -------------------------------------------导出带价格配送单功能
export function exportSendOrderAndPriceFun(data) {
  const params = {
    SERVICE_ID: '10021',
    OTYPE: 3,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ---------------------------------------查询分组功能
export function queryGroupFun(data) {
  const params = {
    SERVICE_ID: '10043',
    OTYPE: 7,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}



// WEBPACK FOOTER //
// ./src/assets/api/sendingOrder.js